export { default } from './GlobalHeader'
